
import { Component, Vue } from "vue-property-decorator";
import { accountApi } from "@/services/api/account/account";
import PanamaLayout from "@/layouts/PanamaLayout.vue";
import {
  ForgotPasswordSecretQuestionCommand,
  IForgotPasswordSecretQuestionCommand
} from "@/services/api/models/ForgotPasswordSecretQuestionCommand.model";
import {
  ForgotPasswordSecretQuestionAnswerCommand,
  IForgotPasswordSecretQuestionAnswerCommand
} from "@/services/api/models/ForgotPasswordSecretQuestionAnswerCommand.model";
import {
  ForgotPasswordSecretQuestionUpdateCommand,
  IForgotPasswordSecretQuestionUpdateCommand
} from "@/services/api/models/ForgotPasswordSecretQuestionUpdateCommand.model";

@Component({
  components: { PanamaLayout },
})
export default class ForgotPasswordSecretQuestion extends Vue {
  private step = 1;
  private secretQuestion = "";
  private answer = "";
  private documentation = "";
  private password = "";
  private repeatPassword = "";
  private errorMessage = "";
  private isErrorMessageShow = false;
  private isIdentificationLoading = false;
  private showIdentificationRequiredError = false;
  private isValidationLoading = false;
  private isPersonalInfoLoading = false;
  private showPassword = false;
  $route: any;
  $t: any;
  
  async mounted() {
    this.documentation = this.$route.params.documentationId ?? "";
  }

  showError(error: string) {
    this.errorMessage = error;
    this.isErrorMessageShow = true;
    setTimeout(() => (this.isErrorMessageShow = false), 8000);
  }

  previous() {
    this.step--;
  }

  async nextIdentification() {
    this.isIdentificationLoading = true;

    if (this.documentation === "" || this.documentation === "") {
      this.showError("Rellene los campos obligatorios.");
      this.showIdentificationRequiredError = true;
      this.isIdentificationLoading = false;
      return;
    }

    try {
      this.secretQuestion = "";
      var data = await accountApi.forgotPasswordSecretQuestion(new ForgotPasswordSecretQuestionCommand(this.documentation));

      if (data && data.secretQuestion) {
        this.secretQuestion = data.secretQuestion;
      }

      this.step = 2;
    } catch (err) {
			if (err?.response?.status === 404 && err.response.data?.errors[0]) {
				this.showError(this.$t(`errors.${err.response.data?.errors[0]}`));
        return;
      }
      if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
        return;
      }
      this.showError(
        "Ha surgido algún error durante la validación los datos. Intentelo de nuevo ó más tarde."
      );
    } finally {
      this.isIdentificationLoading = false;
    }
  }

  async nextValidation() {
    this.isValidationLoading = true;

    if (this.answer === "" || this.answer === "") {
      this.showError("Rellene los campos obligatorios.");
      this.showIdentificationRequiredError = true;
      this.isValidationLoading = false;
      return;
    }

    try {
      await accountApi.forgotPasswordSecretQuestionAnswer(new ForgotPasswordSecretQuestionAnswerCommand(this.documentation, this.answer));
      this.step = 3;
    } catch (err) {
			if (err?.response?.status === 404 && err.response.data?.errors[0]) {
				this.showError(this.$t(`errors.${err.response.data?.errors[0]}`));
        return;
      }
      if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
        return;
      }
      this.showError(
        "Ha surgido algún error durante la validación los datos. Intentelo de nuevo ó más tarde."
      );
    } finally {
      this.isValidationLoading = false;
    }
  }

  async nextPersonalInfo() {
    this.isPersonalInfoLoading = true;

    if (this.password === "" || this.repeatPassword === "") {
      this.showError("Rellene los campos obligatorios.");
      this.isPersonalInfoLoading = false;
      return;
    }

    if (this.password !== this.repeatPassword) {
      this.showError("Las contraseñas deben coincidir");
      this.isPersonalInfoLoading = false;
      return;
    }

    try {
      await accountApi.forgotPasswordSecretQuestionUpdate(new ForgotPasswordSecretQuestionUpdateCommand(this.documentation, this.answer, this.password, this.repeatPassword));
      this.step = 4;
    } catch (err) {
      if (err.response.status === 400 && err.response.data) {
        this.showError(err.response.data);
        return;
      }
      this.showError(
        "Ha surgido algún error durante la validación los datos. Intentelo de nuevo ó más tarde."
      );
    } finally {
      this.isPersonalInfoLoading = false;
    }
  }
}
